import _isNil from 'lodash/isNil';
export function isRefClicked(ref, event) {
  if (_isNil(ref.current)) {
    return false;
  }
  var _ref = event || {},
    target = _ref.target;
  if (target === window || _isNil(target)) {
    return false;
  }
  return ref.current.contains(target);
}